import axios from '@axios'

export const state = {
  notifications: [],
  currentPage: 0,
  perPage: 15,
  totalPages: 0,
  totalRecords: 0,
}
export const getters = {
  allNotifications: (state) => state.notifications,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_NOTIFICATIONS: (state, notifications) => {
    state.notifications = notifications
  },

  REMOVE_NOTIFICATION: (state, notification) => {
    state.notifications = state.notifications.filter(
      (c) => c.id !== notification.id
    )
  },

  MARK_TO_READ: (state) => {
    const unreadNotifications = state.notifications.filter(
      (item) => item.status === false
    )
    unreadNotifications.forEach((item) => {
      item.status = true
    })
  },

  UPDATE_STATUS_NOTIFICATION: (state, announcement) => {
    const index = state.notifications.findIndex((c) => c.id === announcement.id)
    if (index !== -1) {
      state.notifications[index] = {
        ...state.notifications[index],
        status: true,
      }
    }
  },
}

export const actions = {
  async getNotification({ commit }, id) {
    return axios.get(`/notifications/${id}`)
  },

  async getNotifications({ commit }) {
    await axios
      .get(`/notifications`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_NOTIFICATIONS', resp.data.notifications)
        }
      })
      .catch(() => {
        commit('GET_NOTIFICATIONS', [])
      })
  },

  async removeNotification({ commit }, notification) {
    await axios
      .delete('/notifications', { data: notification })
      .then((resp) => {
        if (resp.status === 204) commit('REMOVE_NOTIFICATION', notification)
      })
  },

  async updateStatusNotification({ commit }, notification) {
    commit('UPDATE_STATUS_NOTIFICATION', notification)
  },

  async markToRead({ commit }) {
    commit('MARK_TO_READ')
  },
}
